import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  left: calc(50% + 135px);
  transform: translate(-50%, -50%);
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Img = styled.img`
  margin-bottom: 4px;
`;

export const Title = styled.p`
  ${typographyV2.titleBase};
  color: var(--text-default);
  text-align: center;
`;

export const Description = styled.p`
  ${typographyV2.bodySm};
  color: var(--text-soft);
  max-width: 420px;
  text-align: center;
  margin-bottom: 16px;
`;